<!-- src/components/add-task-form.vue -->
<template>
  <div class="add-task-form">
    <van-nav-bar title="添加任务" left-text="返回" right-text="保存" @click-left="goBack" @click-right="saveTask" />

    <van-form @submit="onSubmit" style="padding-top:20px;">
      <van-cell-group inset>
        <van-field v-model="taskForm.title" name="title" label="标题" placeholder="请输入任务标题"
          :rules="[{ required: true, message: '请输入任务标题' }]" />

        <!-- 省市区选择 -->
        <van-field readonly clickable name="area" :value="areaText" label="省市区" placeholder="点击选择省市区"
          @click="showArea = true" :rules="[{ required: true, message: '请选择省市区' }]" />
        <van-popup v-model="showArea" position="bottom">
          <van-area :area-list="areaList" @confirm="onAreaConfirm" @cancel="showArea = false" />
        </van-popup>

        <!-- 详细地址 -->
        <van-field v-model="taskForm.addressDetail" name="addressDetail" label="详细地址" placeholder="请输入详细地址"
          :rules="[{ required: true, message: '请输入详细地址' }]" />

        <van-field v-model="taskForm.text" name="text" label="内容" type="textarea" placeholder="请输入任务内容" autosize
          :rules="[{ required: true, message: '请输入任务内容' }]" />
        <!-- <van-field
          v-model="taskForm.phone"
          name="phone"
          label="手机号"
          placeholder="请输入联系手机号"
          type="tel"
          :rules="[
            { required: true, message: '请输入手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
          ]"
        /> -->
        <van-field v-model="taskForm.remark" name="remark" label="备注" type="textarea" placeholder="请输入备注信息（可选）"
          autosize />
      </van-cell-group>
    </van-form>
    <i class="rema">注·账号以手机号为准，新注册用户会自动创建用户</i>
  </div>
</template>
<script>
import { createTask } from '@/utils/api.js'
import { areaList } from '@vant/area-data' // 需要安装 @vant/area-data

export default {
  name: 'AddTaskForm',
  data () {
    return {
      showArea: false,
      areaList,
      areaText: '',
      selectedArea: [],
      taskForm: {
        title: '',
        province: '', // 省
        city: '', // 市
        county: '', // 区/县
        addressDetail: '', // 详细地址
        text: '',
        phone: '',
        remark: ''
      },
      userPhone: ''
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    onSubmit (values) {
      this.saveTask()
    },
    onAreaConfirm (values) {
      this.selectedArea = values
      this.areaText = values.map(item => item.name).join('/')

      // 设置省市区字段
      if (values.length >= 3) {
        this.taskForm.province = values[0].name
        this.taskForm.city = values[1].name
        this.taskForm.county = values[2].name
      }

      this.showArea = false
    },
    async saveTask () {
      try {
        // 合并地址信息
        const fullAddress = `${this.taskForm.province}${this.taskForm.city}${this.taskForm.county}${this.taskForm.addressDetail}`
        const taskData = {
          ...this.taskForm,
          address: fullAddress,
          phone: this.userPhone
        }

        const response = await createTask(taskData)
        console.log(response)
        this.$toast.success('任务创建成功')
        this.$router.go(-1)
      } catch (error) {
        this.$toast.fail('任务创建失败')
      }
    }
  },
  mounted () {
    const userInfo = localStorage.getItem('userInfo')
    if (!userInfo) {
      // 用户未登录，跳转到登录页面
      this.$toast.fail('请先登录')
      // 假设登录路由为 /login，根据实际情况调整
      this.$router.push('/login')
      return
    }

    // 解析用户信息
    const user = JSON.parse(userInfo)

    // 检查用户名是否存在
    if (!user.name) {
      this.$toast.fail('用户信息不完整，请重新登录')
      this.$router.push('/login')
    }
    this.userPhone = user.name
  }
}
</script>
<style scoped>
.add-task-form {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.rema {
  padding: 20px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/basic-add.vue